// extracted by mini-css-extract-plugin
export default {"change_data_container":"ChangeUserData_change_data_container__Yq9jP"};